// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-prosemirror-components-Toolbar-Left-_Y8_50"};